<script lang="ts" setup>
import type { StaticPageImage } from '~/types/StaticPageList';

defineProps<{ images: StaticPageImage[] }>();
</script>

<template>
  <div
    v-if="images?.length"
    class="constructor-two-images"
  >
    <AppLink
      v-for="image in images"
      :key="image.url"
      :to="image.url"
      class="constructor-two-images__item"
    >
      <picture class="constructor-two-images__item-img-box">
        <source
          :srcset="`${image.conversions_webp.thumb_390}, ${image.conversions_webp.thumb_780} 2x`"
          type="image/webp"
        />
        <source
          :srcset="image.conversions.thumb_390"
          type="image/jpeg"
        />
        <img
          :alt="image.properties?.alt || image?.text || image.properties?.title"
          :src="image.url"
          class="constructor-two-images__item-image"
          loading="lazy"
        />
      </picture>

      {{ image.text }}
    </AppLink>
  </div>
</template>

<style lang="scss" scoped>
.constructor-two-images {
  @include inner-content;

  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;

  &__item {
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
    font-size: $text-sm;
  }

  &__item-img-box {
    overflow: hidden;
    width: 100%;

    &--bordered {
      border: 1px solid $black;
      border-radius: 12px;
    }
  }

  &__item-image {
    object-fit: cover;
    width: 100%;
    border-radius: 12px;
    aspect-ratio: 110/60;
  }
}
</style>
